import './utils/client';
import {conf} from './services/conf';
import {convincely} from './services/convincely';
import {injectScript, injectStyle} from './services/inject';
import {addScript} from './services/system';
import {paramsReplacer} from './utils/params';
import {urlParams} from './utils/urls';

/**
 * @param {object} [opts]
 */
export function init(opts = {}) {
  const {scripts = [], styles = []} = opts;
  styles.forEach(injectStyle);
  scripts.forEach(addScript);
  load();
}

export function load() {
  if (('fetch' in window && 'getOwnPropertyDescriptors' in Object) || convincely.hasPolyfill) {
    convincely.onload();
  } else {
    convincely.hasPolyfill = true;
    injectScript(`${conf.baseUrl}polyfills.js`);
  }
}

export const appPrefix = 'app-';
export const cachePrefix = 'cache-';
export const stylesPrefix = 'styles-';

/**
 * @param {string} appName
 * @param {string} [feature]
 * @param {string} [urlTemplate]
 */
export function featureToggle(appName, feature, urlTemplate = 'https://app-test.convincely.com/:appName/feature/:feature/') {
  const {featureToggles} = conf;

  if (urlParams.feature) {
    feature = urlParams.feature;
  }

  if (feature && featureToggles && featureToggles[feature]) {
    conf.baseUrl = paramsReplacer(urlTemplate, {appName, feature});
  }
}
